import React, { useEffect, useState, useRef } from "react";
import "react-toastify/dist/ReactToastify.css";
import CenterModal from "../Components/CenterSelectorModal";
import { ToastContainer, toast } from "react-toastify";
import API from "../Services/Report";
import "bootstrap-icons/font/bootstrap-icons.css";
import * as XLSX from "xlsx";

const BirthdayParty = () => {
    const tableRef = useRef(null);

    const today = new Date();
    const formattedToday = today.toISOString().split("T")[0];
    const pastDate = new Date();
    pastDate.setDate(pastDate.getDate() - 90);
    const formattedPastDate = pastDate.toISOString().split("T")[0];

    const [selectedCenter, setSelectedCenter] = useState([]);
    const [detailReport, setDetailReport] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [totalRecord, setTotalRecord] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage] = useState(10);

    const months = [
        { label: "January", value: "1" },
        { label: "February", value: "2" },
        { label: "March", value: "3" },
        { label: "April", value: "4" },
        { label: "May", value: "5" },
        { label: "June", value: "6" },
        { label: "July", value: "7" },
        { label: "August", value: "8" },
        { label: "September", value: "9" },
        { label: "October", value: "10" },
        { label: "November", value: "11" },
        { label: "December", value: "12" },
    ];

    const [search, setSearch] = useState({
        start_month: "",
        end_month: "",
    });

    useEffect(() => {
        getPartyReportData(1);
    }, []);
    useEffect(() => {
        if (currentPage !== 1) {
            getPartyReportData(currentPage);
        }
    }, [recordsPerPage]);
    const handleFieldChange = (e, fieldName) => {
        setSearch((prev) => ({
            ...prev,
            [fieldName]: e.target.value,
        }));
    };

    const handleSelectedCenter = (selectedData) => {
        setSelectedCenter(selectedData || []);
    };

    const handleSearch = () => {
        setCurrentPage(1);
        getPartyReportData(1);
    };

    const getPartyReportData = async (page = 1) => {
        try {
            const centerlist = Array.isArray(selectedCenter)
                ? selectedCenter.join(",")
                : selectedCenter;

            const payload = {
                page_number: page,
                page_size: recordsPerPage,
                start_month: parseInt(search.start_month) || null,
                end_month: parseInt(search.end_month) || null,
                location_id: centerlist && centerlist.length > 0 ? centerlist : null,
            };
            const response = await API.getPartyBirthdayMonthReport(payload);

            const detailData = response?.data?.result || [];
            const totalCount = response?.data?.total_count || 0;
            if (response?.status === 200 && Array.isArray(detailData)) {
                setDetailReport(detailData);
                setTotalRecord(totalCount);
                setCurrentPage(page);
                setTotalPages(Math.ceil(totalCount / recordsPerPage));
            } else {
                toast.error("No detail report found");
                setDetailReport([]);
            }
        } catch (error) {
            console.error(error);
            toast.error("Something went wrong while fetching report");
            setDetailReport([]);
        }
    };

    const getPageNumbers = () => {
        const pages = [];
        const maxVisible = 5;

        if (totalPages <= maxVisible) {
            for (let i = 1; i <= totalPages; i++) pages.push(i);
        } else {
            if (currentPage <= 3) {
                pages.push(1, 2, 3, "...", totalPages);
            } else if (currentPage >= totalPages - 2) {
                pages.push(1, "...", totalPages - 2, totalPages - 1, totalPages);
            } else {
                pages.push(
                    1,
                    "...",
                    currentPage - 1,
                    currentPage,
                    currentPage + 1,
                    "...",
                    totalPages
                );
            }
        }
        return pages;
    };


    const downloadCSV = async () => {
        try {
            const centerlist = Array.isArray(selectedCenter)
                ? selectedCenter.join(",")
                : selectedCenter;

            const payload = {
                page_number: 1,
                page_size: totalRecord,
                start_month: parseInt(search.start_month) || null,
                end_month: parseInt(search.end_month) || null,
                location_id: centerlist && centerlist.length > 0 ? centerlist : null,
            };

            let response;
            let fileName = "Report";
            let result;

            response = await API.getPartyBirthdayMonthReport(payload);

            result = response?.data?.result || [];
            fileName = "MonthWiseBirthdayReport";

            if (!result.length) {
                toast.error("No data found!");
                return;
            }

            const worksheet = XLSX.utils.json_to_sheet(result);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Report");
            XLSX.writeFile(
                workbook,
                `${fileName}.xlsx`
            );
        } catch (error) {
            console.error("Error downloading Excel:", error);
        }
    };

    return (
        <div>
            <ToastContainer />

            <div className="card mt-3">
                <div className="card-header">
                    <h5 className="mb-0">Filter</h5>
                </div>

                <div className="card-body">
                    <div className="row align-items-end">

                        <div className="col-md-3">
                            <CenterModal onSelectCenter={handleSelectedCenter} />
                        </div>

                        <div className="col-md-3">
                            <label>Start Month</label>
                            <select
                                className="form-control form-control-lg"
                                value={search.start_month}
                                onChange={(e) => handleFieldChange(e, "start_month")}
                            >
                                <option value="">Select Month</option>
                                {months.map((m) => (
                                    <option key={m.value} value={m.value}>
                                        {m.label}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="col-md-3">
                            <label>End Month</label>
                            <select
                                className="form-control form-control-lg"
                                value={search.end_month}
                                onChange={(e) => handleFieldChange(e, "end_month")}
                            >
                                <option value="">Select Month</option>
                                {months.map((m) => (
                                    <option key={m.value} value={m.value}>
                                        {m.label}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="col-md-3">
                            <button className="btn btn-success w-100" onClick={handleSearch}>
                                Search
                            </button>
                        </div>

                    </div>
                </div>

            </div>

            <div className="card mt-3">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h4 className="mb-0">
                        Month Wise Birthday Report (<b>{totalRecord}</b>)
                    </h4>

                    {totalRecord > 0 && (
                        <button className="btn btn-primary btn-sm" onClick={downloadCSV}>
                            <i className="fa fa-download"></i>
                        </button>
                    )}
                </div>


                <div className="card-body p-0">
                    <div className="table-responsive">
                        <table className="table table-bordered text-center mb-0">
                            <thead className="table-light">
                                <tr>
                                    <th>#</th>
                                    <th>Center Name</th>
                                    <th>Customer Name</th>
                                    <th>DOB</th>
                                    <th>Birthday Age</th>
                                    <th>Assoc Ph.</th>
                                    <th>Gender</th>
                                    <th>Assoc Email</th>
                                    <th>Membership Level</th>
                                    <th>Last Visit Date</th>
                                </tr>
                            </thead>

                            <tbody>
                                {detailReport?.length > 0 ? (
                                    detailReport.map((item, index) => (
                                        <tr key={index}>
                                            <td>{(currentPage - 1) * recordsPerPage + index + 1}</td>

                                            <td>{item["Center Name"] || "N/A"}</td>
                                            <td>{item["Cust Name"] || "N/A"}</td>
                                            <td>{item["DoB"] || "N/A"}</td>
                                            <td>
                                                {item["Birthday Age"]?.trim() === "Yrs"
                                                    ? "N/A"
                                                    : item["Birthday Age"] || "N/A"}
                                            </td>
                                            {/* <td>{item["Birthday Age"] || "N/A"}</td> */}
                                            <td>{item["Assoc Ph."] || "N/A"}</td>
                                            <td>{item["Gender"] || "N/A"}</td>
                                            <td>{item["Assoc Email"] || "N/A"}</td>
                                            <td>{item["Membership Level"] || "N/A"}</td>
                                            <td>
                                                {item["Last Visit Date"]
                                                    ? new Date(item["Last Visit Date"]).toLocaleDateString()
                                                    : "N/A"}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="10">No data available</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                    </div>

                    {/* PAGINATION */}
                    <nav>
                        <ul className="pagination justify-content-center mt-3">
                            <li className={`page-item ${currentPage === 1 && "disabled"}`}>
                                <button
                                    className="page-link"
                                    onClick={() => getPartyReportData(currentPage - 1)}
                                >
                                    Previous
                                </button>
                            </li>

                            {getPageNumbers().map((page, index) => (
                                <li
                                    key={index}
                                    className={`page-item ${page === currentPage ? "active" : ""} ${page === "..." && "disabled"}`}
                                >
                                    {page === "..." ? (
                                        <span className="page-link">...</span>
                                    ) : (
                                        <button
                                            className="page-link"
                                            onClick={() => getPartyReportData(page)}
                                        >
                                            {page}
                                        </button>
                                    )}
                                </li>
                            ))}

                            <li className={`page-item ${currentPage === totalPages && "disabled"}`}>
                                <button
                                    className="page-link"
                                    onClick={() => getPartyReportData(currentPage + 1)}
                                >
                                    Next
                                </button>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    );
};

export default BirthdayParty;
